/* ============================================================
   Kälma — Magnesio Complex 8 en 1 (slug 'kalma').
   Cargado por layout/landing.liquid (case 'kalma').
   Bloques: galería (thumbs) · selección de bundle (.kl-bundle) · videos UGC
   (autoplay muted + tap para oír) · disparo del modal Releasit COD · sticky.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N (packs) para que el pedido lleve las
   unidades reales (Dropi) y el total quede en el precio del bundle. Releasit
   lee input[name="quantity"] del DOM al disparar. NO usar _rsiV2.setState como
   primer path. Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- Galería del buy-box (lee src de los thumbs) ---------- */
(function () {
  var thumbs = [].slice.call(document.querySelectorAll('#thumbs img'));
  var src = thumbs.map(function (i) { return i.getAttribute('src'); });
  var gi = 0;
  window.gSet = function (i) {
    if (!src.length) return;
    gi = (i + src.length) % src.length;
    var main = document.getElementById('gmain');
    if (main) main.src = src[gi];
    document.querySelectorAll('.kl-thumb').forEach(function (t, k) { t.classList.toggle('active', k === gi); });
  };
  window.gStep = function (d) { window.gSet(gi + d); };
})();

/* ---------- Videos UGC: autoplay obliga muted → tap para oír ---------- */
window.unmute = function (btn) {
  var card = btn.closest('.kl-vcard'), v = card && card.querySelector('video');
  if (!v) return;
  if (v.muted) {
    document.querySelectorAll('.kl-vcard video').forEach(function (o) { o.muted = true; });
    document.querySelectorAll('.kl-unmute').forEach(function (b) { b.innerHTML = '🔇 Toca para oír'; });
    v.muted = false; v.play(); btn.innerHTML = '🔊 Sonando';
  } else {
    v.muted = true; btn.innerHTML = '🔇 Toca para oír';
  }
};

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var KALMA_RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function kalmaFindReleasitButton() {
  for (var i = 0; i < KALMA_RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(KALMA_RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var kalmaSelectedVariantId = null;
var kalmaSelectedQty = 1;

function kalmaSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

function kalmaBundleQty(el) {
  var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
  return q || 1;
}

/* ---------- Selección de bundle ---------- */
function pick(el) {
  document.querySelectorAll('.kl-bundle').forEach(function (b) { b.classList.remove('sel'); });
  el.classList.add('sel');
  var id = el.getAttribute('data-bundle-variant-id');
  if (id) {
    kalmaSelectedVariantId = id;
    kalmaSelectedQty = kalmaBundleQty(el);
    kalmaSetVariantOnAllForms(id, kalmaSelectedQty);
  }
}
window.pick = pick;

function kalmaTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || kalmaSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || kalmaSelectedQty;
  if (variantId) kalmaSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = kalmaFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = kalmaFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.kalmaTriggerCOD = kalmaTriggerCOD;
window.openCheckout = function () { kalmaTriggerCOD(null); };

/* ---------- Init: bundle preseleccionado (.sel o el primero) ---------- */
(function () {
  var active = document.querySelector('.kl-bundle.sel') || document.querySelector('.kl-bundle');
  if (active) pick(active);
})();
